var $0f32c2d6739d5745$exports = {};
// logga in
let $0f32c2d6739d5745$var$url = "https://pizzaapi-kzs1.onrender.com/api/login" //URL till mitt API
;
/* funktion för att läsa in datan i formuläret */ const $0f32c2d6739d5745$var$loginBtnEl = document.getElementById("loginBtn");
$0f32c2d6739d5745$var$loginBtnEl.addEventListener("click", (e)=>{
    e.preventDefault();
    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;
    let error = document.getElementById("error");
    if (username == "" || password == "") {
        //throw error
        error.innerHTML = "You must fill in everything!";
        return;
    } else $0f32c2d6739d5745$var$loginUser(username, password);
});
/* Funktion för att logga in */ async function $0f32c2d6739d5745$var$loginUser(username, password) {
    let user = {
        username: username,
        password: password
    };
    let success = document.getElementById("success");
    let error = document.getElementById("error");
    const response = await fetch($0f32c2d6739d5745$var$url, {
        method: "POST",
        headers: {
            "content-type": "Application/json"
        },
        body: JSON.stringify(user)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) error.innerHTML = `${data.error}`;
    else {
        localStorage.setItem("token", data.response.token); //spara JWT token
        localStorage.setItem("username", user.username);
        success.innerHTML = `${data.response.message}`;
        error.innerHTML = "";
        setTimeout(logInRedirect, 1000);
        function logInRedirect() {
            window.location.href = "admin.html";
        }
    }
}


//# sourceMappingURL=login.68df4e1f.js.map
